// Mirrors DocumentDefaults::MarketOverviewSlot: a placeholder in a template's default pages that fills
// with the property's Market Overview pages when a document is created. It is never a page library entry.
export const MARKET_OVERVIEW_SLOT = {
  id: 0,
  name: 'Market Overview',
  template_type: 'DocumentDefaults::MarketOverviewSlot'
} as const;

export function isMarketOverviewSlot(page?: { template_type?: string } | null): boolean {
  return page?.template_type === MARKET_OVERVIEW_SLOT.template_type;
}
